<template>
    <div class="support-container temp-box-shadow">
        <my-form ref="form">
            <div class="d-flex flex-wrap">
                <div class="col-md-6 col-12 fs-18 pr-12">
                    <div class="fw-500 fs-32 mb-10">
                        Get in touch with our help
                        team to help you to grow
                        your business
                    </div>
                    <div class="fw-500 fs-18 mb-1">Contact</div>
                    <div class="fs-16 fw-400 mb-1 flex"><v-icon class="mr-3">mdi-phone-outline</v-icon>1300 968 085</div>
                    <div class="fs-16 fw-400 flex"><v-icon class="mr-3">mdi-email-outline</v-icon>info@printdrop.com.au</div>
                    <div class="fw-500 fs-32 mb-2 mt-14">Have any questions?</div>
                    <div class="fw-400 fs-24">Check if we already have an answer to them</div>
                    <v-btn @click="goToFaq" class="mt-8 fs-18 mb-10" color="blue" dense height="48" style="padding:12px 20px; color:white;" >Go to FAQ</v-btn>
                </div>
                <div class="col-md-6 col-12">
                    <div class="support-form-container">
                        <div class="fs-18 fw-500 mb-8">Contact form</div>
                        <div class="fs-14 fw-400 mb-1">Topic</div>
                        <!--                    <v-select style="font-weight: 400; font-size: 14px" v-model="supportForm.topic" :items="topicOptions" outlined dense height="48"></v-select>-->
                        <v-text-field :rules="[validationRules.required]" v-model="supportForm.topic" outlined dense height="48"></v-text-field>
                        <div class="fs-14 fw-400 mb-1">Your name</div>
                        <v-text-field :rules="[validationRules.required]" v-model="supportForm.name" outlined dense height="48"></v-text-field>
                        <div class="fs-14 fw-400 mb-1">Email</div>
                        <v-text-field :rules="[validationRules.required, validationRules.email]" v-model="supportForm.email" outlined dense height="48"></v-text-field>
                        <div class="fs-14 fw-400 mb-1">Message</div>
                        <v-textarea :rules="[validationRules.required]" spellcheck="false" style="font-weight: 400; font-size:14px" class="fw-400" v-model="supportForm.message" dense outlined height="80"></v-textarea>

                        <div class="d-flex flex-row hover align-center file-input">
                            <v-file-input
                                counter
                                color="blue"
                                show-size
                                truncate-length="20"
                                label="Attach File"
                                v-model="file"
                                :loading="uploading"
                                @change="uploadFile(file)"
                            ></v-file-input>
                        </div>

                        <v-checkbox
                            v-model="supportForm.personalData"
                            style="color: #4353FF"
                            color="new_blue_drop"
                            class="support-checkbox"
                            :label="`I hereby give consent my for my personal data in the form above to be processed`"
                        ></v-checkbox>
                        <v-btn :loading="loading" :disabled="!supportForm.personalData" @click="sendMessage" class="mt-4 fs-18" color="blue" height="48" dense style="padding:12px 20px; color:white;" >Send message</v-btn>
                    </div>
                </div>
            </div>
        </my-form>
    </div>
</template>
<script>
import {sendForm} from "@/api/support";
import {upload} from "@/api/upload";

export default {
    data: ()=>{
        return {
            supportForm: {},
            topicOptions: [
                'Example option no. 1',
                'Example option no. 2',
                'Example option no. 3',
            ],
            file: null,
            loading: false,
            uploading: false,
            uploadedFile: null,
        }
    },
    methods: {
        goToFaq(){
            window.open(this.$root.base_url+'/page/faq', '_blank');
        },
        initData(){
            this.supportForm = {};
            this.file = null;
            this.uploadedFile = null;
        },
        sendMessage(){
            if(this.$refs.form.my_validate()){
                this.loading = true;

                let obj = {
                    'form': this.supportForm,
                    'path': 'form-files',
                    'file_src': this.uploadedFile,
                }

                sendForm(obj).then(res=>{
                    this.loading = false;
                    this.$store.commit('app/ADD_MESSAGE', {text: this.$t('Form submitted successfully'), type: 'success'});
                    this.initData();
                }).catch(e=>{
                    this.$store.commit('app/ADD_MESSAGE', {text: this.$t('Something went wrong...'), type: 'error'});
                    this.loading = false;
                })
            }
        },
        uploadFile(file){
            if(file){
                console.log('file ', file)
                var formData = new FormData();
                formData.append("files[]", file, file.name);
                formData.append('path', '');
                this.uploading = true;
                upload(formData, 'form-files').then(response => {
                    this.uploading = false;
                    this.uploadedFile = response.data[0];
                }).catch(e => {
                    this.uploading = false;
                })
            }
        }
    }
}
</script>

<style>
.file-input .v-label  {
    color: #2F80ED!important;
    font-weight: 400!important;
    font-size: 20px!important;
}
#app .file-input .v-text-field__slot label:not(.v-label--active){
    font-size: 20px!important;
    top: 6px !important;
}
</style>
